import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/AI.css";
import AnimatedBack from "../images/AnimatedBack.gif";
import AI1 from "../images/AI1.png";
import AI2 from "../images/AI2.png";
import AI3 from "../images/AI3.png";
import AI4 from "../images/AI4.png";
import AI5 from "../images/AI5.png";
import AI6 from "../images/AI6.png";
import AI7 from "../images/AI7.webp";
import AI8 from "../images/AI8.gif";
import AI9 from "../images/AI9.png";
import AI10 from "../images/AI10.png";
import AI11 from "../images/AI11.png";
import AI12 from "../images/AI12.png";
import AI13 from "../images/AI13.png";
import AI14 from "../images/AI14.png";

function AI() {
  return (
    <>
      <Header />
      <div className="AI">
       <div className="Ai-above">
         <img className="Ai-img" src={AnimatedBack} alt="background" />
        <div className="Ai-above-info">
          <p className="Ai-p">AI and ML</p>
          <p className="Ai-p">Software</p>
          <p className="Ai-p1">Highly efficient & dedicated AI / ML developer.</p>
        </div>
       </div>

        <div className="Ai-main">
          <p className="Ai-main-p">
            With our extensive experience in AI technology and a global
            distribution network, we've successfully delivered hundreds of AI
            products and solutions to organizations worldwide. Leveraging our AI
            development expertise, we can transform your ideas into
            production-ready software, from accelerating decision-making to
            automating repetitive tasks.
          </p>
          <div
            className="Webd-main2"
            style={{
              backgroundColor: "#f8f9fa",
              paddingTop: "40px",
              paddingBottom: "50px",
            }}
          >
            <p className="Webd-main2-p">
              Our AI Application Development Services
            </p>
            <p className="Webd-main2-p1">
              We offer real-time, customizable AI solutions with advanced data
              analytics.
            </p>
            <div className="Appd-main2-boxes">
              <div
                className="Appd-main2-box"
                style={{ width: "600px", backgroundColor: "white" }}
              >
                <img className="Appd-main2-img" src={AI1} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Machine learning (ML)
                </p>
                <p style={{ marginTop: "20px" }}>
                  We leverage machine learning techniques to develop AI
                  solutions that collect unstructured data and transform it into
                  valuable insights, driving business growth.
                </p>
              </div>
              <div
                className="Appd-main2-box"
                style={{ width: "600px", backgroundColor: "white" }}
              >
                <img className="Appd-main2-img" src={AI2} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Business intelligence
                </p>
                <p style={{ marginTop: "20px" }}>
                  Our AI engineers develop strategies for optimizing processes,
                  analyzing customer behavior, forecasting trends, and
                  evaluating performance.
                </p>
              </div>
            </div>
            <div className="Appd-main2-boxes">
              <div
                className="Appd-main2-box"
                style={{ width: "600px", backgroundColor: "white" }}
              >
                <img className="Appd-main2-img" src={AI3} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Processing of Natural Language (NLP)
                </p>
                <p style={{ marginTop: "20px" }}>
                  Our AI developers utilize NLP and NLU technologies to help
                  businesses analyze consumer feedback and sentiment, enhancing
                  customer engagement and driving revenue growth.
                </p>
              </div>
              <div
                className="Appd-main2-box"
                style={{ width: "600px", backgroundColor: "white" }}
              >
                <img className="Appd-main2-img" src={AI4} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Computer Vision
                </p>
                <p style={{ marginTop: "20px" }}>
                  Leveraging Amazon Rekognition and Deep Learning-based Visual
                  Search, our AI engineers have created solutions for object
                  recognition and image classification.
                </p>
              </div>
            </div>
            <div className="Appd-main2-boxes">
              <div
                className="Appd-main2-box"
                style={{ width: "600px", backgroundColor: "white" }}
              >
                <img className="Appd-main2-img" src={AI5} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Assistant by Voice
                </p>
                <p style={{ marginTop: "20px" }}>
                  Our AI engineers also develop voice assistants that utilize
                  natural language processing and voice recognition, enhancing
                  brand awareness and boosting productivity through voice
                  search.
                </p>
              </div>
              <div
                className="Appd-main2-box"
                style={{ width: "600px", backgroundColor: "white" }}
              >
                <img className="Appd-main2-img" src={AI6} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  ChatBots Development
                </p>
                <p style={{ marginTop: "20px" }}>
                  Our AI development team builds chatbots that enable
                  personalized interactions, enhancing customer loyalty and
                  retention.
                </p>
              </div>
            </div>
          </div>
          <img className="Ai-img1" src={AI8} alt="" />
          <div className="Ai-main1">
            <p className="Ai-main1-p">
              Why Choose Purohit Technosoft for Hiring AI/ML Developers?
            </p>
            <p className="Ai-main1-p1">
              Choose Purohit Technosoft as your trusted AI development partner.
            </p>
            <div className="Ai-main1-sections">
              <div className="Ai-main1-section">
                <div className="Ai-main1-box">
                  <img className="Ai-main1-img2" src={AI9} alt="" />
                  <p>Certified Developers</p>
                </div>
                <div className="Ai-main1-box">
                  <img className="Ai-main1-img2" src={AI10} alt="" />
                  <p>100% Confidentiality</p>
                </div>
                <div className="Ai-main1-box">
                  <img className="Ai-main1-img2" src={AI11} alt="" />
                  <p>Flexible Hiring Models</p>
                </div>
              </div>
              <img className="Ai-img2" src={AI7} alt="" />
              <div className="Ai-main1-section">
                <div className="Ai-main1-box">
                  <p>Comprehensive Reporting</p>
                  <img className="Ai-main1-img2" src={AI12} alt="" />
                </div>
                <div className="Ai-main1-box">
                  <p>24/7 Support</p>
                  <img className="Ai-main1-img2" src={AI13} alt="" />
                </div>
                <div className="Ai-main1-box">
                  <p>Flexible Working Hours</p>
                  <img className="Ai-main1-img2" src={AI14} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default AI;
